jQuery(function ($) {
    var value_gb;
    $("#device-information .memory-block p").each(function () {
      $(this).on("click", function () {
        if (!$(this).hasClass("memory-active")) {
          $(this).addClass("memory-active");
          $(this).removeClass("drop-shadow");
          $(this).siblings().removeClass("memory-active");
          $(this).siblings().addClass("drop-shadow");
  
          //   Change Memory on click to the selected memories
          value_gb = $(this).text();
          $("#selected-memory-value").text(value_gb);
          $(".device-size").text(value_gb);
        }
  
        //   Change Price according to Memory Selection
        let dataram = $(this).attr("data-ram");
        console.log(dataram);
  
        $("[data-ramprice]").each(function () {
          // console.log($(this).data("ramprice"));
          if ($(this).data("ramprice") == dataram) {
            $(this).removeClass("d-none");
            $(this).siblings().addClass("d-none");
  
            let ramPrice = $(".payment-blocks .get-price-block").text(
              $(this).text().replace("$", "")
            );
            let ramWithTax = (
              (parseFloat(ramPrice[0].innerText) -
                parseFloat(minDown) -
                parseFloat(tab_credit)) /
              24
            ).toFixed(2);
  
            $(".put-price-back-block").text("$" + ramWithTax);
          }
        });
      });
    });
  
    //   Modal Open/Close
    $("#device-information .description-modal").on("click", function () {
      if (!$("#device-information .modal-container").hasClass("active")) {
        $("#device-information .modal-container").toggleClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $(".modal-container .modal-data i").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    //   Continue Button
    //   $(".open-next-accordion").on("click", function () {
    //     $(".accordion-item").each(function(){
    //         $(".accordion-item")
    //     })
    //   });
  
    //   Select Color and Change Image Accordingly
    var color_id;
    $(".outline-green").each(function () {
      $(this).on("click", function () {
        color_id = $(this).attr("data-colorid");
        $(this).addClass("active-outline");
        $(this).siblings().removeClass("active-outline");
  
        $(".mobile-image-color").each(function () {
          $(".mobile-image-color").addClass("d-none");
          $("#" + color_id).removeClass("d-none");
        });
  
        // Dynamic Color Name Text Change
        $color_name = $(this).children("p")[0].innerHTML;
        $(".change-color").text($color_name);
        $(".device-color").text($color_name);
      });
    });
  });
  